import { createContext, ReactNode, useContext } from 'react';

import { url } from 'constants/index';
import { usePaginatedRequest } from 'hooks/api/usePaginatedRequest';

class EntityTypesError extends Error {}

export enum EntityTypes {
  Competitions = 'competitions',
  Seasons = 'seasons',
  Rounds = 'rounds',
  Fixtures = 'fixtures',
  Teams = 'teams',
  Players = 'players',
  Doubles = 'doubles',
  Venues = 'venues',
  Localities = 'localities',
  Contracts = 'contracts',
}

export type EntityType = {
  id: number;
  name: EntityTypes;
  createdOn: string;
  modifiedOn: string;
};

type EntityTypesType = {
  entityTypes: Array<EntityType>;
  error: EntityTypesError;
};
export const EntityTypesContext = createContext<EntityTypesType>({} as EntityTypesType);

export const EntityTypesProvider = ({ children }: { children: ReactNode }) => {
  const { data, error } = usePaginatedRequest<EntityType>({
    endpoint: url.entity_types,
    disableSportId: true,
  });

  return (
    <EntityTypesContext.Provider value={{ entityTypes: data?.items, error }}>
      {children}
    </EntityTypesContext.Provider>
  );
};

export const useEntityTypes = () => useContext(EntityTypesContext);

export const useEntityType = (entityTypeName: EntityTypes) =>
  useContext(EntityTypesContext)?.entityTypes?.find(item => item.name === entityTypeName);
